// extracted by mini-css-extract-plugin
module.exports = {"centered":"ActivationExpired_centered__32eIW","centeredText":"ActivationExpired_centeredText__2ONBo"};